import Login from "utils/login";

declare global {
  interface Window {
    Login: any;
  }
}

window.Login = Login;
